import { render, staticRenderFns } from "./dropping.vue?vue&type=template&id=62332893&"
import script from "./dropping.vue?vue&type=script&lang=js&"
export * from "./dropping.vue?vue&type=script&lang=js&"
import style0 from "./dropping.vue?vue&type=style&index=0&id=62332893&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports